
import React,{Component} from "react";

import {
  Card,
  CardHeader,
  ListGroup,
  ListGroupItem,
  FormSelect,
  Col
} from "shards-react";


import { toast } from 'react-toastify';
import { AtomSpinner } from 'react-epic-spinners';
import firebase from '../firebase';

import '../style.css'

export default class ClassStudent extends Component{

  constructor(props) {
    super(props);
  
    this.state = {  
                    selected_class:undefined,
                    selected_student:'class1',
                    loading:false,
                    class_list:[],
                    student_list:[],
                  };

    this.getStyle = this.getStyle.bind(this);
    this.get_class_list = this.get_class_list.bind(this);
    this.get_student_list = this.get_student_list.bind(this);
    this.changeSelectStudent = this.changeSelectStudent.bind(this);
    this.setClass = this.setClass.bind(this);
    this.linear_search = this.linear_search.bind(this);
  }


  linear_search = (key,arr)=>{

      for(var i=0;i<arr.length;i++){
          if(key===arr[i].roll_no){
            return arr[i];
          }
      }

      return -1;

  }

  changeSelectStudent=(id)=>{
        this.setState({selected_student:id});
        console.log(id);

        var data = this.linear_search(id,this.state.student_list)
        
        if(data!==-1){
            this.props.setSelectedStudent(data);  
        }
        
  }


  setClass = (evt)=>{
      this.setState({selected_class:evt.target.value},this.get_student_list);
  }

  get_student_list=()=>{

      var class_name = this.state.selected_class;
      console.log(class_name);
      if(class_name===undefined || class_name==="Select Class" || class_name==="No Class List"){
          return;
      }
      var that = this;

      this.setState({loading:true,student_list:[]});      
      firebase.firestore().collection('StudentList').doc(class_name).get().then(function(doc){
              var student_list = doc.data().students;
              console.log(student_list);
              that.setState({student_list:student_list,loading:false});
      }).catch(function(err){
        console.log(err);
        that.setState({loading:false});
      })
  }


  get_class_list = ()=>{
      var that = this;
      this.setState({loading:true});
      firebase.firestore().collection('ClassList').doc('list').get().then(function(doc){
          var class_list = doc.data().classes;
          class_list.shift();  //removes first element in array
          console.log(class_list);
          that.setState({loading:false,class_list:class_list});
          that.get_student_list();
      }).catch(function(err){
          that.setState({loading:false});
          toast('Unable to get class list !', {containerId: 'A'});
      })
  }


  getStyle = (id,type) =>{
      
      if(this.state.selected_student===id){
          if(type==="background"){
            return {backgroundColor: '#4169e1'}
          }
          if(type==="word"){
            return {color: 'white'}
          }
      }

      if(type==="background"){
            return {backgroundColor: 'white'}
      }
      if(type==="word"){
            return {color: 'black'}
      }
    
  }

  componentDidMount(){
    this.get_class_list();
  }

  render(){
    return(
     <Card small className="mb-4 pt-3">
        <CardHeader className="border-bottom text-center">
        		<h4 className="mb-0">{"Class"}</h4>
        			<Col sm="12" className="d-flex mb-2 mb-sm-0" style={{marginTop: '5px'}}>
              			<Col md="12" className="form-group">
            				
             				<FormSelect onChange={this.setClass}>
                        {
                          !(this.state.class_list.length===0) &&
                          <option>Select Class</option>
                        }
                        {

                          this.state.class_list.map((item,i)=>{
                            return (<option key={i}>{item}</option>)
                          })
                        }
                        {
                          (this.state.class_list.length===0) &&
                          <option>No Class List</option>
                        }
            				</FormSelect>
            			</Col>
            		</Col>
   		 </CardHeader>
    <ListGroup flush className={"scroll_list-group"}>
    	
          {   
                this.state.student_list.map((item,i)=>{
                            return (<StudentItem key={i} 
                                                 data={item}
                                                 ChangeSelect={this.changeSelectStudent}
                                                 getStyle={this.getStyle} 
                                                />
                                  )
                })
          }

          {
            ((this.state.student_list.length===0) && !this.state.loading)&&

            <ListGroupItem className="px-4" style={{marginTop: '10%',marginBottom: '10%'}}>
                <div className="progress-wrapper" >
                    <strong className=" d-block mb-2" style={{textAlign:"center",fontSize: 20,color:'blue'}}>
                          {"No Students Available"}
                    </strong>
                   

                </div>
            </ListGroupItem>

          }


         
          {
            (this.state.loading  && !this.state.selected_class===undefined ) &&

            <ListGroupItem className="px-4" style={{marginTop: '10%',marginBottom: '10%',marginLeft: '30%'}}>
                <div className="progress-wrapper" >
                    <strong className=" d-block mb-2" style={{textAlign:"center"}}>
                         <AtomSpinner color="blue" /> 
                    </strong>
                   

                </div>
            </ListGroupItem>

          }


      
    </ListGroup>
  </Card>
      )
  }
}




class StudentItem extends Component{
  render(){
    return(
      <ListGroupItem className="px-4"  style={this.props.getStyle(this.props.data.roll_no,'background')} onClick={()=>{this.props.ChangeSelect(this.props.data.roll_no)}}>
        <div className="progress-wrapper" style={this.props.getStyle(this.props.data.roll_no,'word')}>
          <strong className=" d-block mb-2">
            {this.props.data.name}
          </strong>
        </div>
      </ListGroupItem>

    )
  } 
}